<template>
  <div
    v-if="enableSteckdosen"
    id="steckdosen_container"
    class="matrix_optionsTable matrix_table"
  >
    <div class="matrix_tableHeader">
      {{ $t("Sockets") }}
    </div>
    <div id="steckdosen_popup" class="sidebar_popup">
      <div id="steckdosen_toolbar">
        <div id="steckdosen_toolbar">
          <div
            v-for="(socket, indexS) in getSockets"
            :key="indexS"
            class="steckdosen_item steckdosen_item_draggable"
            :data-info="JSON.stringify(socket)"
          >
            <img :src="socket.image_url" />
            <span class="opacity"></span>
            <span class="select_dosen">+</span>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
      <ul v-show="total" class="dimensions-list">
        <li
          v-for="(dosen, indexD) in getSteckdosen.dosens"
          :id="'steckdosen-item-' + indexD"
          :key="indexD"
          class="newdosen_item"
        >
          <span class="number">{{ indexD + 1 }}</span>
          <div
            class="newdosen-icon dosen"
            :style="{ 'background-image': 'url(' + dosen.imageSrc + ')' }"
          ></div>
          <div class="posxy">
            <div class="pos_input">
              <label :for="'dosenX-' + indexD">{{ $t("X:") }}</label>
              <input
                :id="'dosenX-' + indexD"
                v-model="dosen.left"
                type="number"
                min="0"
                class="steckdosen_input"
                @keydown.enter="onEnter"
              />
              <span class="cm">{{ $t("cm") }}</span>
            </div>
            <div class="pos_input">
              <label :for="'dosenY-' + indexD">{{ $t("Y:") }}</label>
              <input
                :id="'dosenY-' + indexD"
                v-model="dosen.bottom"
                type="number"
                min="0"
                class="steckdosen_input"
                @keydown.enter="onEnter"
              />
              <span class="cm">{{ $t("cm") }}</span>
            </div>
          </div>
          <div class="delete-dosen" @click="removeSteckDosen(indexD)">
            <appAwesomeIcon icon="trash-alt" useClass="fa fa-trash-o" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";
import { i18n } from "../../i18n.js";

export default {
  props: ["index"],
  data: function () {
    return {
      show: 0
    };
  },
  computed: {
    ...mapState(useImageEditorStore, [
      "getSteckdosen",
      "getPOIEVariables",
      "getDefaultSockets"
    ]),
    ...mapState(useWebproductStore, ["getSweetAlert"]),
    total: function () {
      return this.getSteckdosen.dosens.length;
    },
    getSockets: function () {
      return this.getDefaultSockets;
    },
    enableSteckdosen: function () {
      return parseFloat(this.getPOIEVariables.enableSteckdosen);
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, ["removeDosen", "addNewDosen"]),
    onEnter: function (event) {
      event.preventDefault();
    },
    addDosen: function (type, e) {
      this.addNewDosen({
        type: type
      });
    },
    showEmpty: function (level) {
      return this.total + level <= 6 && this.total;
    },
    hoverItem: function (index) {
      jQuery("li.newdosen_item").removeClass("hover");
      jQuery("li#steckdosen-item-" + index).addClass("hover");
    },
    removeHover: function () {
      jQuery("li.newdosen_item").removeClass("hover");
    },
    removeSteckDosen: function (index) {
      var POIEVariables = this.getPOIEVariables;
      const widget = this;

      this.getSweetAlert({
        text: i18n.t(POIEVariables.Texts.steckdosen.remove),
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: i18n.t("Cancel"),
        confirmButtonText: i18n.t("Ok")
      }).then(userAction => {
        if (userAction.isConfirmed) {
          widget.removeDosen(index);
        } else {
          return;
        }
      });
    }
  },
  mounted: function () {
    jQuery(".steckdosen_item").draggable({
      appendTo: "body",
      revert: "invalid",
      helper: function () {
        var _self = jQuery(this);
        var data = _self.data();
        var info = data.info;
        return jQuery("<div>")
          .addClass("steckdosen_item_placeholder ")
          .css({
            "background-image": "url(" + info.image_url + ")",
            "background-size": "contain",
            width: _self.width(),
            height: _self.height(),
            "background-repeat": "no-repeat",
            "background-position": "center center",
            "z-index": "9999"
          });
      },
      drag: function (event, ui) {},
      start: (function () {
        return function (event, ui) {};
      })(),
      cursor: "move"
    });
  }
};
</script>
